const luckysheetConfigsetting = {
    autoFormatw: false,
    accuracy: undefined,
    total: 0,

    allowCopy: true,
    showtoolbar: true,
    showinfobar: true,
    showsheetbar: true,
    showstatisticBar: true,
    pointEdit: false,
    pointEditUpdate: null,
    pointEditZoom: 1,

    userInfo: false,
    userMenuItem: [],
    myFolderUrl: null,
    functionButton: null,

    showConfigWindowResize: true,
    enableAddRow: true,
    addRowCount: 100,
    enableAddBackTop: true,
    enablePage: true,
    pageInfo: null,


    editMode: false,
    beforeCreateDom: null,
    workbookCreateBefore: null,
    workbookCreateAfter: null,
    remoteFunction: null,
    fireMousedown: null,
    plugins:[],
    forceCalculation:false,//强制刷新公式，公式较多会有性能问题，慎用

    defaultColWidth:73,
    defaultRowHeight:19,

    defaultTextColor: '#000',
    defaultCellColor: '#fff',

    // 底部统计行（浮层 DOM 模拟）
    // 启用条件：enable=true 且 columns 非空，二者缺一不可
    summaryRow: {
        enable: false,          // 是否启用统计行
        columns: [],            // 必填：要显示合计的列索引数组，如 [0, 2, 5]；为空则不计算
        sheets: null,           // 指定哪些 sheet 启用：null/[] = 所有 sheet；[0, 2] 按 index 指定
        formatter: null,        // 可选 (sum, colIndex) => string，自定义显示文本
        height: 24,             // 统计行高度（px）
    },
}

export default luckysheetConfigsetting;
